import React from 'react';
import styled from 'styled-components';
import { respondTo } from 'styles/helper';
import useFlowManager from 'lib/hooks/useFlowManager';
import { Image, Link, Icons } from 'components/common';
import foxIcon from 'images/brands/fox/FoxNow_Icon.svg';
import nationIcon from 'images/brands/nation/icon_nation.svg';

const links = {
  apple: 'https://apps.apple.com/us/app/fox-now-watch-tv-sports/id571096102',
  google: 'https://play.google.com/store/apps/details?id=com.fox.now&amp;hl=en_US',
};

const MobileApps = (): JSX.Element => {
  const { isNation } = useFlowManager();
  return (
    <StyledMobileApps>
      <div className="mobileApp">
        {isNation ? (
          <>
            <Image src={nationIcon} alt="Nation Icon" width={60} height={60} />
            <p className="download">
              Download the FOX NATION <br /> App on your mobile device
            </p>
          </>
        ) : (
          <>
            <Image src={foxIcon} alt="Fox Icon" width={60} height={60} />
            <p className="download">
              Download the App <br /> on your mobile device
            </p>
            <div className="link">
              <Link href={links.apple} passHref>
                <Icons.AppStoreBadge />
              </Link>
            </div>
            <div className="link">
              <Link href={links.google} passHref>
                <Icons.GoogleBadge />
              </Link>
            </div>
          </>
        )}
      </div>
    </StyledMobileApps>
  );
};

export default MobileApps;

const StyledMobileApps = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  height: 100%;
  font-size: 16px;
  text-align: center;
  ${respondTo.bp_767`
    display: none;
	`}
  .mobileApp {
    position: absolute;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    transform: translateY(-15px);
  }
  .download {
    margin-bottom: 4rem;
    font-family: Graphik, serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 18px;
    letter-spacing: 0;
    opacity: 0.5;
    text-align: center;
  }
  .link {
    margin-bottom: 2rem;
    display: block;
    width: 120px;
  }
`;
